import type {
  ExternalConnectionLinks,
  ExternalLinkTemplate,
} from "@/hooks/api/use-external-connection-links";

export interface ExternalRecord {
  source_record_id: string;
  source_record_type: string;
  hubspot_contact_id?: string;
  hubspot_content_id?: string;
}

export function getExternalConnectionLink(
  record: ExternalRecord,
  connections?: ExternalConnectionLinks[],
): string | null {
  const [system, recordType] = record.source_record_type.split(".");

  if (!system || !record.source_record_id) return null;

  // Find matching connection
  const connection = connections?.find(
    (conn) => conn.type === system.toLowerCase(),
  );
  if (!connection) return null;

  // Find matching template
  const template = connection.link_templates.find(
    (t: ExternalLinkTemplate) =>
      t.system === system.toLowerCase() &&
      t.record_type === recordType.toLowerCase(),
  );
  if (!template) return null;

  // Some Marketo records have a suffix that we don't want to include in the source record id
  // e.g. 128_Marketing Folder -> 128
  const sourceRecordId = record.source_record_id.split("_")[0];
  return template.template
    .replace("{source_record_id}", encodeURIComponent(sourceRecordId))
    .replace(
      "{hubspot_contact_id}",
      encodeURIComponent(record.hubspot_contact_id || ""),
    )
    .replace(
      "{hubspot_content_id}",
      encodeURIComponent(record.hubspot_content_id || ""),
    );
}

export function getExternalSystemName(recordType: string): string {
  const [system] = recordType.split(".");
  return system.charAt(0).toUpperCase() + system.slice(1);
}
